export const CASH_ACTION_PERMISSIONS = [
  {key:"branch_cash.advance_repayment",label:"Record advance repayments",arabic:"تسجيل سداد السلف",
    description:"Record cash an employee repays into a permitted branch cash box.",descriptionAr:"تسجيل النقدية التي يسددها الموظف إلى صندوق فرع مسموح به.",category:"branch_cash"},
  {key:"branch_cash.hand_to_office",label:"Hand cash to the office",arabic:"تسليم كاش للإدارة",
    description:"Hand branch box cash to a collector for delivery to the office.",descriptionAr:"تسليم نقدية صندوق الفرع إلى المحصّل لتوصيلها إلى الإدارة.",category:"branch_cash"},
  {key:"branch_cash.opening_balance",label:"Set opening balance",arabic:"تحديد الرصيد الافتتاحي",
    description:"Set an opening balance in a permitted branch cash box.",descriptionAr:"تحديد الرصيد الافتتاحي لصندوق فرع مسموح به.",category:"branch_cash"},
] as const;
export type CashActionPermission=typeof CASH_ACTION_PERMISSIONS[number]["key"];
/** Used only to snapshot the owner's explicitly approved, one-time cutover. */
export function legacyCashActionGrants(role:{id:string;name:string;workspace_id:string|null;permissions:string[]}) {
  const has=(key:string)=>role.permissions.includes(key);
  const finance=["admin","system_admin","finance_manager"].includes(role.id)||
    !!role.workspace_id&&["admin","administrator","system admin","owner","finance manager"].includes(role.name.trim().toLowerCase());
  return {
    "branch_cash.advance_repayment":has("branch_cash.record"),
    "branch_cash.hand_to_office":has("branch_cash.record"),
    "branch_cash.opening_balance":has("branch_cash.record")&&has("branch_cash.manage")&&finance,
  };
}
